import React, { useEffect } from 'react';

import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
export const AddTranFieldDef = () => {
  var addTranFdJsonArr = [
    {
      fieldName: 'File Receipt Date and Time',
      description:
        'Date and time the Electronic Eligibility Management System received the submission file.Note: This field is only found on Near Real Time Transactions.',
    },
    {
      fieldName: 'File Processing Date',
      description:
        'Date the Electronic Eligibility Management System received and processed submission file.',
    },
    {
      fieldName: 'Severity(CES/CDB)',
    },
    {
      fieldName: 'Severity(CSP)',
    },
    {
      fieldName: 'Employee ID',
      description: 'The member number of the employee.',
    },
    {
      fieldName: 'Medicare ID',
      description:
        'Medicare number of the member. [This field is used for GPS file processing]',
    },
    {
      fieldName: 'Subscriber ID',
      description:
        'The member number of the subscriber. [This field is used for PRIME file processing]',
    },
    {
      fieldName: 'Medicaid ID',
      description:
        'The ID given by the state for a subscriber. [This field is used for CSP file processing]',
    },

    {
      fieldName: 'Name',
      description: 'Name of member.',
    },
    {
      fieldName: 'Plan ID',
      description: 'Plan Identifier.',
    },
    {
      fieldName: 'Rel',
    },
    {
      fieldName: 'Type',
    },
    {
      fieldName: 'Transaction Source',
    },
    {
      fieldName: 'Warning Name',
      description:
        'Identifies the cause of the warning. The update was made to the destination system. To view a description of the warning, place the mouse pointer over the warning name.',
    },
    {
      fieldName: 'Status',
      description:
        'Status of the current transaction. The valid values for Status are:  Complete , Complete with Warnings, GPS-Complete and GPS-WQ.',
    },
    {
      fieldName: 'Data Field',
      description:
        'Identifies the submission field where the warning occurred.',
    },
    {
      fieldName: 'Customer Data',
      description:
        'Identifies the value or the incorrect data field which was submitted.',
    },
    {
      fieldName: 'Source Data (Eligibility System Data)',
      description:
        'Identifies the corresponding value the Source Data (Eligibility System Data) has recorded for that particular field.',
    },
    {
      fieldName: 'Coverage Type',
    },
    {
      fieldName: 'Coverage Start Date',
      description: 'The effective date of coverage for the coverage type.',
    },
    {
      fieldName: 'Plan Variation',
      description: 'Plan Variation Code.',
    },
    {
      fieldName: 'Reporting Code',
      description: 'Reporting Code.',
    },
  ];

  var severityCodeJsonArr = [
    {
      sevCode: '4',
      description: 'Warning',
      explantion:
        'Subscribers update is made to the destination system, but certain data requires update for accuracy. Example: Address Overlay',
    },
    {
      sevCode: '5',
      description: 'PCP',
      explantion:
        'Subscribers update is made to the destination system, missing subscriber has been loaded in a Gatekeeper Plan without a valid PCP.',
    },
  ];
  var severityCodeCSPJsonArr = [
    {
      sevCode: '1-Critical',

      explantion:
        'Transaction is held up in the Electronic Eligibility Management System process and updates are not sent back to CSP.',
    },
    {
      sevCode: '4-Error',

      explantion:
        'Subscribers update is made to the destination system, but certain data requires update for accuracy. The segment which generated the error may not be sent to CSP but the rest of the member will be processed',
    },
    {
      sevCode: '5-Warning',

      explantion:
        'For information only. Subscribers update is made to the destination system, but certain data requires update for accuracy. Warning is used to alert the EEA that some unexpected values were received.',
    },
  ];
  var relJsonArr = [
    {
      relCode: '01',
      description: 'Spouse',
    },
    {
      relCode: '02',
      description: 'Surviving Spouse',
    },
    {
      relCode: '09',
      description: 'Step Child',
    },
    {
      relCode: '15',
      description: 'Ward',
    },
    {
      relCode: '18',
      description: 'Employee',
    },
    {
      relCode: '19',
      description: 'Child',
    },
    {
      relCode: '20',
      description: 'Student',
    },
    {
      relCode: '21',
      description: 'Handicapped Dependent',
    },
    {
      relCode: '22',
      description: 'Handicapped Student',
    },
    {
      relCode: '23',
      description: 'Sponsored Dependant',
    },
    {
      relCode: '34',
      description: 'Retiree',
    },
    {
      relCode: '35',
      description: 'Newborn (Internal Use Only)',
    },
    {
      relCode: '36',
      description: 'Other',
    },
    {
      relCode: '35',
      description: 'Newborn (Internal Use Only)',
    },
    {
      relCode: '38',
      description: 'Collateral Dependant',
    },
    {
      relCode: '53',
      description: 'Life Partner',
    },
  ];
  var typeJsonArr = [
    {
      type: 'Add',
      description: 'Transaction added',
    },
  ];
  var tranSourceJsonArr = [
    {
      tranSource: 'ELIGIBILITY SYSTEM',
      description:
        'Transaction was not submitted on the file and was built from the eligibility system',
    },
    {
      tranSource: 'FILE',
      description: 'Transaction submitted on the file',
    },
  ];
  var covTypeJsonArr = [
    {
      type: 'D',
      definition: 'Dental',
    },
    {
      type: 'EX',
      definition: 'Prescription Drug',
    },
    {
      type: 'GX',
      definition: 'Prescription Drug',
    },
    {
      type: 'HX',
      definition: 'Prescription Drug',
    },
    {
      covTyPE: 'JX',
      definition: 'Prescription Drug',
    },
    {
      type: 'KX',
      definition: 'Prescription Drug',
    },
    {
      type: 'L',
      definition: 'Life',
    },
    {
      type: 'M',
      definition: 'Medical',
    },
    {
      type: 'MH',
      definition: 'Medical Supplement',
    },
    {
      type: 'MS',
      definition: 'Executive Medical',
    },
    {
      type: 'NX',
      definition: 'Prescription Drug',
    },
    {
      type: 'RX',
      definition: 'Prescription Drug',
    },
    {
      type: 'S',
      definition: 'Stand Alone',
    },
    {
      type: 'V',
      definition: 'Vision',
    },
  ];
  return (
    <>
      <p>
        The Error and Warning Summary page displays a list of all errors and
        warnings and the corresponding count for a file processing date. The
        errors and warnings are separated by owner, customer or eligibility
        analyst. Click on the error or warning name to view the list of all the
        transactions with that corresponding error or warning.
      </p>
      <Table.Container title="Manual Static Table">
        <Table.TableHeader>
          <Table.TableHeaderRow>
            <Table.Column>Field Name</Table.Column>
            <Table.Column>Description</Table.Column>
          </Table.TableHeaderRow>
        </Table.TableHeader>
        {addTranFdJsonArr.map((item) => (
          <Table.TableBody>
            {!item.fieldName.includes('Severity') &&
              item.fieldName != 'Rel' &&
              item.fieldName != 'Type' &&
              item.fieldName != 'Transaction Source' &&
              item.fieldName != 'Coverage Type' && (
                <Table.Row>
                  <Table.Cell>{item.fieldName}</Table.Cell>
                  <Table.Cell>{item.description}</Table.Cell>
                </Table.Row>
              )}
            {item.fieldName === 'Severity(CES/CDB)' && (
              <Table.Row>
                <Table.Cell>Severity(CES/CDB)</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Status Code</Table.Column>
                        <Table.Column>Description</Table.Column>
                        <Table.Column>Explanation</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {severityCodeJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.sevCode}</Table.Cell>
                          <Table.Cell>{item2.description}</Table.Cell>
                          <Table.Cell>{item2.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
            {item.fieldName === 'Severity(CSP)' && (
              <Table.Row>
                <Table.Cell>Severity(CSP)</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Status Code - Description</Table.Column>

                        <Table.Column>Explanation</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {severityCodeCSPJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.sevCode}</Table.Cell>

                          <Table.Cell>{item2.explantion}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
            {item.fieldName === 'Rel' && (
              <Table.Row>
                <Table.Cell>Rel</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Rel Codes</Table.Column>

                        <Table.Column>Description</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {relJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.relCode}</Table.Cell>

                          <Table.Cell>{item2.description}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}

            {item.fieldName === 'Type' && (
              <Table.Row>
                <Table.Cell>Type</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Type</Table.Column>

                        <Table.Column>Definition</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {typeJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.type}</Table.Cell>

                          <Table.Cell>{item2.description}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
            {item.fieldName === 'Transaction Source' && (
              <Table.Row>
                <Table.Cell>Transaction Source</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Transaction Source</Table.Column>

                        <Table.Column>Description</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {tranSourceJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.tranSource}</Table.Cell>

                          <Table.Cell>{item2.description}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
            {item.fieldName === 'Coverage Type' && (
              <Table.Row>
                <Table.Cell>Coverage Type</Table.Cell>
                <Table.Cell>
                  {' '}
                  <Table.Container title="">
                    <Table.TableHeader>
                      <Table.TableHeaderRow>
                        <Table.Column>Coverage Type</Table.Column>

                        <Table.Column>Definition</Table.Column>
                      </Table.TableHeaderRow>
                    </Table.TableHeader>

                    <Table.TableBody>
                      {covTypeJsonArr.map((item2) => (
                        <Table.Row>
                          <Table.Cell>{item2.type}</Table.Cell>

                          <Table.Cell>{item2.definition}</Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.TableBody>
                  </Table.Container>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.TableBody>
        ))}
      </Table.Container>
    </>
  );
};
